import { ActionOperationMethod, ActionTrigger } from '@domain/action';
import { uuidv4 } from '@studio/utils/id';
import { DEFAULT_TIMING_FUNCTION } from '../timing-functions';
export function createAction(options = {}) {
    var _a, _b;
    if (!options.target) {
        if (options.templateId) {
            throw new Error('Actions with templateId requires a target.');
        }
        if (options.stateId) {
            throw new Error('Actions with state IDs requires a target.');
        }
    }
    if ((_a = options.triggers) === null || _a === void 0 ? void 0 : _a.find(trigger => trigger === ActionTrigger.TouchEnd)) {
        options.triggers.push(ActionTrigger.TouchCancel);
    }
    const action = {
        id: uuidv4(),
        triggers: ((_b = options.triggers) === null || _b === void 0 ? void 0 : _b.length) ? options.triggers : [ActionTrigger.MouseDown],
        operations: [
            {
                method: options.method || ActionOperationMethod.SetState,
                value: options.method === ActionOperationMethod.OpenUrl
                    ? ''
                    : options.stateId || undefined,
                target: options.target || undefined,
                animation: DEFAULT_ACTION_ANIMATION
            }
        ],
        disabled: false,
        templateId: options.templateId,
        preventClickThrough: options.preventClickThrough
    };
    return action;
}
export function registerActionEventHandlers(actionHandler) {
    const triggers = {};
    for (const trigger in ActionTrigger) {
        triggers[ActionTrigger[trigger]] = (event, forceClearStates) => actionHandler.callback(event, ActionTrigger[trigger], forceClearStates);
    }
    return triggers;
}
export function isReservedAction(action) {
    return !!action.templateId;
}
export function hasActionPreventClickthrough(dataElement) {
    const actions = dataElement === null || dataElement === void 0 ? void 0 : dataElement.actions;
    if (!actions) {
        return false;
    }
    return actions.some(action => !action.disabled && action.preventClickThrough);
}
export function hasActionTargetUrl(dataElement) {
    const actions = dataElement === null || dataElement === void 0 ? void 0 : dataElement.actions;
    if (!actions) {
        return false;
    }
    return actions.some(action => !action.disabled &&
        action.operations.some(op => op.method === ActionOperationMethod.OpenUrl && op.value));
}
export function isCancelTrigger(trigger) {
    return (trigger === ActionTrigger.MouseLeave ||
        trigger === ActionTrigger.TouchEnd ||
        trigger === ActionTrigger.TouchCancel);
}
export function isStateActionMethod(method) {
    const stateMethods = [
        ActionOperationMethod.SetState,
        ActionOperationMethod.RemoveState,
        ActionOperationMethod.ClearStates
    ];
    return stateMethods.indexOf(method) > -1;
}
export const DEFAULT_ACTION_ANIMATION = {
    timingFunction: DEFAULT_TIMING_FUNCTION,
    duration: 0.2
};
